import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { modifiedDateTime } from "helpers/utils";
import { useOrderStatus } from "hooks";
import {
  useListOrderScan,
  useListOrderScanActionType,
  useListOrderScanStatus,
  useOrderScanRemove,
} from "hooks/order-scan/useOrderScan";
import useUserList from "pages/RouteManagement/useUserList";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setListBusColumn } from "store/actions";
import {
  getInitOrderScanParams,
  mapArrayToObject,
  statusOption,
} from "./utils";

const ListHistoryScan = props => {
  const { isShowListOnly, scanId } = props;
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["bus"]);
  const inputSearchTrackingKey = useRef(null);
  const [allowFocusInputTrackingKey, setAllowFocusInputTrackingKey] =
    useState(true);

  /* ================================== START INIT STATE ==================================== */
  const [columnsTable, setColumnsTable] = useState([]);
  const [orderScanParams, setOrderScanParams] = useState(
    getInitOrderScanParams
  );
  const [statusListAllOptions, setStatusListAllOptions] = useState([]);
  const { optionUserScan } = useUserList();

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  // BUS LIST

  const onSuccessList = () => {
    setAllowFocusInputTrackingKey(true);
  };

  const onErrorList = () => {
    setAllowFocusInputTrackingKey(true);
  };

  const { mutate: mutateOrderScanRemove, isLoading: isLoadingScanRemove } =
    useOrderScanRemove({
      onSuccess: data => {
        refetchListOrderScan();
      },
      onError: messError => {},
    });

  const {
    isLoading,
    isFetching,
    data: listOrderScan,
    refetch: refetchListOrderScan,
  } = useListOrderScan({ params: orderScanParams }, onSuccessList, onErrorList);

  const { refetch: fetchListOrderScanStatus, data: listOrderScanStatus } =
    useListOrderScanStatus({
      params: {
        columnFilter: {
          // "filter[record_status]": "O",
        },
        page: -1,
      },
    });

  const {
    refetch: fetchListOrderScanActionType,
    data: listOrderScanActionType,
  } = useListOrderScanActionType({
    params: {
      columnFilter: {
        // "filter[record_status]": "O",
      },
      page: -1,
    },
  });

  const formatStatus = cell => {
    const status = statusListAllOptions.find(
      item => parseInt(item.value) === cell
    );
    return <div>{status?.label}</div>;
  };

  const onFetchStatusListSuccess = response => {
    setStatusListAllOptions(
      response.map(i => ({ value: parseFloat(i.value), label: i.label }))
    );
  };

  const { refetch: onFetchStatusList, data: orderStatusList } = useOrderStatus(
    onFetchStatusListSuccess
  );

  useEffect(() => {
    if (orderScanParams && orderScanParams.run) {
      refetchListOrderScan();
    }
  }, [orderScanParams]);

  useEffect(() => {
    setOrderScanParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
      scan_id: scanId,
    }));
    fetchListOrderScanStatus();
    fetchListOrderScanActionType();
    onFetchStatusList();
  }, [t]);

  useEffect(() => {
    if (listOrderScan) {
      initColumn();
    }
  }, [listOrderScan, orderStatusList, listOrderScanActionType, optionUserScan]);

  useEffect(() => {
    if (allowFocusInputTrackingKey) {
      inputSearchTrackingKey?.current?.focus();
    }
  }, []);

  useEffect(() => {
    let intervalId = null;
    if (allowFocusInputTrackingKey) {
      intervalId = setInterval(() => {
        inputSearchTrackingKey?.current?.focus();
      }, 500);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [allowFocusInputTrackingKey]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const initColumn = () => {
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListBusColumn(field, value));
    initColumn();
  };

  const formatOptionsTable = (cell, name = "", label) => {
    return statusOption.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {label || ""}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    const order_status = columnFilter["filter[order_status]"];
    delete columnFilter["filter[order_status]"];

    const dateFilter = modifiedDateTime(columnFilter, "filter[scanner_date]");

    setOrderScanParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : orderScanParams.sort,
      columnFilter: {
        ...columnFilter,
        ...dateFilter,
      },
      page: page || 1,
      sizePerPage: sizePerPage || 10,
      order_status: order_status,
    }));
  };

  const onSearchAllHandle = value => {
    setOrderScanParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const clickDetailOrder = (row, index) => {
    window.open(
      `/manage-orders/${row?.object?.id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const clickDetailPhaseScan = (row, index) => {
    // navigation(`/phase-scan-barcode/${row.scanId}`);
    window.open(
      `/phase-scan-barcode/${row.scanId}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {},
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const listRowAction = [
    {
      icon: <i className="bx bx-copy-alt font-size-24 text-success" />,
      text: "Xem chi tiết đợt quét kiện gần nhất",
      onClick: clickDetailPhaseScan,
      conditionVisible: {
        status: [2],
      },
    },
    {
      icon: <i className="bx bx-trash fa-lg text-danger font-size-20" />,
      text: "Xóa",
      onClick: row => {
        mutateOrderScanRemove({ id: row.id });
      },
      conditionVisible: {
        status: [3],
      },
    },
    {
      icon: <i className="fas fa-eye fa-lg text-primary" />,
      text: "Xem chi tiết đơn",
      onClick: clickDetailOrder,
      conditionVisible: {
        status: [1, 2],
      },
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "scan_code",
      text: "Mã quét kiện",
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: "Mã quét kiện",
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "object_code",
      text: "Mã kiện",
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: "Mã kiện",
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "object_ref_code",
      text: "Mã tham chiếu",
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: "Mã tham chiếu",
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "status",
      text: "Trạng thái quét kiện",
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: "Trạng thái quét kiện",
        }),
        options: listOrderScanStatus || [],
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell) {
          return formatOptionsTable(
            cell,
            "status",
            listOrderScanStatus?.[cell]
          );
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
      allowExport: true,
    },
    {
      dataField: "action_type",
      text: "Loại quét kiện",
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: "Loại quét kiện",
        }),
        options: listOrderScanActionType || [],
      }),
      formatter: (cell, row) => {
        return listOrderScanActionType?.[cell];
      },
      allowExport: true,
    },
    {
      dataField: "order_status",
      text: t("table.order_status"),
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.order_status"),
        }),
        options: mapArrayToObject(statusListAllOptions) || [],
        id: "order_status",
      }),
      formatter: cell => {
        return formatStatus(cell);
      },
      allowExport: true,
    },
    {
      dataField: "scanner_id",
      text: "Người quét",
      formatter: (cell, row) => {
        return row?.scanner?.display_name;
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={orderScanParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "scanner_date",
      text: "Ngày quét",
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={orderScanParams.columnFilter}
        />
      ),
      allowExport: true,
    },
  ];

  const handleKeyDown = event => {
    if (
      event.key.toLowerCase() === "enter" &&
      inputSearchTrackingKey.current.value
    ) {
      setOrderScanParams({
        ...orderScanParams,
        tracking_key: inputSearchTrackingKey.current.value,
      });
      inputSearchTrackingKey.current.value = "";
      inputSearchTrackingKey.current.focus();
      // Enter key is pressed
      // Perform your desired action here
      // toggleModal();
    }
  };

  const InputSearchTrackingKey = (
    <div className="d-flex align-items-center gap-2">
      <div className="search-box mb-md-2 me-2 d-inline-block flex-grow-1">
        <div className="position-relative" style={{ width: "305px" }}>
          <input
            // disabled={
            //   // isLoadingScanReceivce || isLoadingScanInfo
            // }
            style={{ width: "100%" }}
            ref={inputSearchTrackingKey}
            // value={searchTerm}
            type="search"
            onKeyDown={handleKeyDown}
            disabled={isLoading || isFetching}
            className="form-control"
            placeholder="Tìm kiếm kiểm kiện. (Enter để kiểm tra)"
          />
          <i
            className="bx bxs-barcode search-icon"
            style={{ color: "#50a5f1" }}
          />
          {orderScanParams.tracking_key && (
            <div
              className="d-flex gap-1 fw-bold font-size-14"
              style={{
                position: "absolute",
                top: "7px",
                right: "-147px",
              }}
            >
              ( Tracking key:{" "}
              <div className="text-info" style={{ fontStyle: "italic" }}>
                {orderScanParams.tracking_key}
              </div>
              )
              <i
                onClick={() => {
                  setOrderScanParams({
                    ...orderScanParams,
                    tracking_key: undefined,
                  });
                }}
                className="mdi mdi-close-thick text-danger font-size-15"
                style={{ cursor: "pointer" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <h4 className="text-primary">
        Danh sách yêu cầu đã quét ({listOrderScan?.totalCount || 0})
      </h4>

      {!isShowListOnly ? (
        <div className="page-content">
          <MetaTags>
            <title>{"Yêu cầu quét kiện"}</title>
          </MetaTags>
          <div className="container-fluid">
            <BreadcrumbWithLink
              title={
                "Yêu cầu quét kiện" + ` (${listOrderScan?.totalCount || 0})`
              }
              breadcrumbItems={[
                { name: t("title.manager") },
                { name: "Yêu cầu quét kiện" },
              ]}
            />

            <Row>
              {/* Modal START*/}
              <Col className="col-12"></Col>
              {/* Modal E N D*/}
              <Col
                className="col-12"
                onFocus={() => {
                  setAllowFocusInputTrackingKey(false);
                }}
              >
                <Card>
                  <CardBody>
                    <RemoteDataTable
                      // selectRow={selectRowCheckbox}
                      keyField="id"
                      data={listOrderScan?.items || []}
                      columns={columnsTable}
                      page={orderScanParams.page}
                      sizePerPage={orderScanParams.sizePerPage}
                      totalSize={listOrderScan?.totalCount || 0}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandler}
                      rowEvents={rowEventsHandler}
                      listMultipleRowAction={listMultipleRowAction}
                      listRowAction={listRowAction}
                      loading={isLoading}
                      customSearchComponent={InputSearchTrackingKey}
                    ></RemoteDataTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      ) : (
        <RemoteDataTable
          // selectRow={selectRowCheckbox}
          keyField="id"
          data={listOrderScan?.items || []}
          columns={columnsTable}
          page={orderScanParams.page}
          sizePerPage={orderScanParams.sizePerPage}
          totalSize={listOrderScan?.totalCount || 0}
          onTableChange={handleTableChange}
          onSearchAllHandle={onSearchAllHandle}
          optionShowColumnHandel={optionShowColumnHandler}
          rowEvents={rowEventsHandler}
          listMultipleRowAction={listMultipleRowAction}
          listRowAction={listRowAction}
          loading={isLoading}
          // customSearchComponent={InputSearchTrackingKey}
        ></RemoteDataTable>
      )}
    </React.Fragment>
  );
};

ListHistoryScan.propTypes = {
  isShowListOnly: PropTypes.bool,
  scanId: PropTypes.any,
};

export default ListHistoryScan;
